import { message } from 'hljd'
import { hashHistory } from 'react-router'
import { isStoreHidden, isStoreAccount, getMerchantInfo } from '../..'
import {
  JIAMENG_GOODS_PATH,
  PROPERTY_WEDDING_PHOTO_ID,
  CHOOSE_WEDDING_PHOTO_PATH_COMMON,
  PUBLISH_MEAL_PATH
} from '@constant'

// 根据是否门店账号获取发布套餐去哪个页面
export const goToPubMeal = () => {
  let msg = isStoreHidden()
  if (msg != 'success') {
    message.error(msg)
    return false
  }
  if (isStoreAccount()) {
    hashHistory.push(JIAMENG_GOODS_PATH)
  } else {
    // if (getMerchantInfo().property_id == PROPERTY_WEDDING_PHOTO_ID) {
    //   hashHistory.push(CHOOSE_WEDDING_PHOTO_PATH_COMMON)
    // } else {
    hashHistory.push(PUBLISH_MEAL_PATH)
    // }
  }
}

export const getPublishMealPath = () => {
  let msg = isStoreHidden()
  if (msg != 'success') {
    message.error(msg)
    return false
  }
  if (isStoreAccount()) {
    return JIAMENG_GOODS_PATH
  } else {
    if (getMerchantInfo().property_id == PROPERTY_WEDDING_PHOTO_ID) {
      return CHOOSE_WEDDING_PHOTO_PATH_COMMON
    } else {
      return PUBLISH_MEAL_PATH
    }
  }
}

export const isEmojiCharacter = substring => {
  for (let i = 0; i < substring.length; i++) {
    let hs = substring.charCodeAt(i)
    if (0xd800 <= hs && hs <= 0xdbff) {
      if (substring.length > 1) {
        let ls = substring.charCodeAt(i + 1)
        let uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000
        if (0x1d000 <= uc && uc <= 0x1f77f) {
          return true
        }
      }
    } else if (substring.length > 1) {
      let ls = substring.charCodeAt(i + 1)
      if (ls == 0x20e3) {
        return true
      }
    } else {
      if (0x2100 <= hs && hs <= 0x27ff) {
        return true
      } else if (0x2b05 <= hs && hs <= 0x2b07) {
        return true
      } else if (0x2934 <= hs && hs <= 0x2935) {
        return true
      } else if (0x3297 <= hs && hs <= 0x3299) {
        return true
      } else if (
        hs == 0xa9 ||
        hs == 0xae ||
        hs == 0x303d ||
        hs == 0x3030 ||
        hs == 0x2b55 ||
        hs == 0x2b1c ||
        hs == 0x2b1b ||
        hs == 0x2b50
      ) {
        return true
      }
    }
  }
}
